/* global atlas */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../LoadingIndicator';
import ErrorNotification from '../../common/ErrorNotification';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

const { REACT_APP_AZURE_MAP_KEY } = process.env;
const styles = () => ({
  mapContainer: {
    display: 'flex',
    width: '100%',
    height: '100%'
  },
  map: {
    minWidth: '600px',
    minHeight: '500px',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  }
});

export class MultiPointMap extends Component {
  static propTypes = {
    shipments: PropTypes.array,
    mapId: PropTypes.string.isRequired
  };
  state = {
    mapLoaded: false,
    errors: null
  };
  async componentDidMount() {
    //  atlas.setSubscriptionKey(REACT_APP_AZURE_MAP_KEY);
    this.loadMap();
  }
  loadMap = () => {
    const { shipments, mapId } = this.props;
    const component = this;
    const map = new atlas.Map(mapId, {
      center: [-98.5795, 39.828175],
      zoom: 4,
      //Add your Azure Maps subscription key to the map SDK. Get an Azure Maps key at https://azure.com/maps
      authOptions: {
        authType: 'subscriptionKey',
        subscriptionKey: REACT_APP_AZURE_MAP_KEY
      }
    });
    //Wait until the map resources are ready.
    map.events.add('ready', function() {
      //Add a style control to the map.
      map.controls.add(
        new atlas.control.StyleControl({
          style: 'dark',
          //Optionally specify which map styles you want to appear in the picker.
          //All styles available with the S0 license tier appear by default in the control.
          //If using a S1 tier license, you can use the mapStyles option to add the 'satellite' and 'satellite_road_labels' styles to the control.
          mapStyles: [
            'road',
            'grayscale_dark',
            'night',
            'road_shaded_relief',
            'satellite',
            'satellite_road_labels'
          ]
        }),
        {
          position: 'bottom-right'
        }
      );

      /* Construct a zoom control*/
      const zoomControl = new atlas.control.ZoomControl();

      /* Add the zoom control to the map*/
      map.controls.add(zoomControl, {
        position: 'top-right'
      });

      const datasource = new atlas.source.DataSource();
      map.sources.add(datasource);

      shipments.forEach(shipment => {
        const originPoint = [shipment.originLongitude, shipment.originLatitude];
        const destinationPoint = [
          shipment.destinationLongitude,
          shipment.destinationLatitude
        ];
        if (shipment.originLongitude && shipment.destinationLatitude) {
          datasource.add(
            new atlas.data.LineString([originPoint, destinationPoint])
          );
          //Create a layer to render the line data.
          const lineLayer = new atlas.layer.LineLayer(datasource);
          map.layers.add(lineLayer);
        }
      });
    });

    component.setState({ mapLoaded: true });
  };

  render() {
    const { classes, mapId } = this.props;
    const { errors, mapLoaded } = this.state;
    if (!errors) {
      return (
        <div className={classes.mapContainer}>
          <div id={mapId} className={classes.map} />
          {!mapLoaded && <LoadingIndicator />}
        </div>
      );
    } else {
      return <ErrorNotification message={this.state.errors} />;
    }
  }
}
const styledMultiPointMap = withStyles(styles)(MultiPointMap);
export default withNamespaces()(styledMultiPointMap);
